var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGripHorizontalSolid = function SvgGripHorizontalSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7v8h8V7zm10 0v8h8V7zm10 0v8h8V7zM4 9h4v4H4zm10 0h4v4h-4zm10 0h4v4h-4zM2 17v8h8v-8zm10 0v8h8v-8zm10 0v8h8v-8zM4 19h4v4H4zm10 0h4v4h-4zm10 0h4v4h-4z"
  })));
};
export default SvgGripHorizontalSolid;